import { DefaultLinkModel, RightAngleLinkModel } from "@projectstorm/react-diagrams";

export default class ComponentLinkModel extends RightAngleLinkModel {
  constructor() {
    super({
      type: "component-link",
      width: 5,
      color: "red",
    });
  }
}
